/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of printers (patients) to display or load printers */


(function () {
  'use strict';
  angular.module('vcdms.vcprinter')
    .component('printerlist', {
      restrict: 'E',
      bindings: {
        printers: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="printer in vm.printers">
            <td>{{printer.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editPrinter(printer)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removePrinter(printer)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Printer', 'PrinterHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Printer, PrinterHelper, vertxEventBusService) {
          let vm = this;
          vm.editPrinter = PrinterHelper.editPrinter;
          vm.removePrinter = removePrinter;

          vm.$onInit = function () {

            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.printers)) {
              vm.printers = Printer.$search();
            }
          }; // $onInit()


          function removePrinter(printer) {
            printer.active = false;
            printer.$save();
          }

          const printersUpdateHandler = function (message) {
            if (angular.isDefined(vm.printers)) {
              vm.printers.$refresh().$then(function () {
                // $log.debug('debug: printerlist refreshed printers');
              }, function (error) {
                $log.debug('debug: printerlist refresh printers failed: ', error);
              });
            }
          };

          vertxEventBusService.on('printers.update', {}, printersUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('printers.update', {}, printersUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());